import { render, staticRenderFns } from "./IngredientTable.vue?vue&type=template&id=58775fee&scoped=true"
import script from "./IngredientTable.vue?vue&type=script&lang=js"
export * from "./IngredientTable.vue?vue&type=script&lang=js"
import style0 from "./IngredientTable.vue?vue&type=style&index=0&id=58775fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58775fee",
  null
  
)

export default component.exports